import React from 'react';
import configuration from '../../constants/Configuration';
import properties from '../../constants/Properties';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import storeManager from '../../store/StoreManager';
import mouseUtils from './MouseUtils';

const dragManager = {
    scaleProperties: undefined,
    dragElement: undefined,
    callBackFunction: undefined,
    offsetPoint: undefined,
    startPositionLeft: 0,
    startPositionTop: 0,
    isSlide: false,
    gap: 0,
    oldTime: 0,

    getDragOffset(offsetPoint) {
        var dragX = 0;
        var dragY = 0;

        if (offsetPoint != undefined) {
            if (offsetPoint.x > 0)
                dragX =  (offsetPoint.x - this.startPositionLeft);

            if (offsetPoint.y > 0)
                dragY =  offsetPoint.y - this.startPositionTop;
        }

        if (dragX < 0)
            dragX = 0;

        if (dragY < 0)
            dragY = 0;

        return {x: dragX, y: dragY};
    },
    cloneCanvas (oldCanvas) {
        var newCanvas = document.createElement('canvas');
        var context = newCanvas.getContext('2d');

        newCanvas.width = oldCanvas.width;
        newCanvas.height = oldCanvas.height;

        context.drawImage(oldCanvas, 0, 0);

        return newCanvas;
    },
    prepareClone(target, callBackFunction, dragOffset, isSlide = false) {
        const date = new Date();
        const currentTime = date.getTime();

        if (currentTime - this.oldTime < 300) {
            this.oldTime = currentTime;
            return;
        }

        if (!target)
            return;

        this.oldTime = currentTime;

        if (this.dragElement && this.dragElement.parentNode)
            document.body.removeChild(this.dragElement);

        if (target.nodeName == 'CANVAS')
            this.dragElement = this.cloneCanvas(target);
        else {
            var holder = document.createElement('div');
            holder.style.position = 'absolute';

            var clone = target.cloneNode(true);
            clone.style.position = 'absolute';
            clone.style.left = '0px';
            clone.style.paddingTop = '0px';
            clone.style.paddingLeft = '0px';
            clone.style.display = 'block';

            var gapX = 5;
            var gapY = 5;
            var icon = document.createElement('div');
            icon.id = 'dropIcon';
            icon.style.position = 'absolute';
            icon.style.borderColor = 'red';
            icon.style.borderWidth = 4;
            icon.style.borderStyle = 'solid';
            icon.style.top = '0px';
            icon.style.left = '0px';
            icon.style.cursor = '-webkit-grabbing';

            if (target.id && target.id.indexOf('ListItemRenderer') != -1) {
                if (target.className == 'background') {
                    clone.style.top = '12px';
                    gapX = 7;
                    gapY = 3;
                } else {
                    clone.style.top = '0px';
                    gapX = 7;
                    gapY = 7;
                }
            } else if (target.id && target.id.indexOf('MediaImagesItemRenderer') != -1) {
                clone.style.top = '0px';
                gapX = 11;
                gapY = 11;
            } else
            {
                clone.style.top = '0px';
            }

            icon.style.width = (target.clientWidth - gapX) + 'px';
            icon.style.height = (target.clientHeight - gapY) + 'px';

            holder.appendChild(clone);
            holder.appendChild(icon);

            this.dragElement = holder;
        }

        document.body.appendChild(this.dragElement);

        const globalPosition = target.getBoundingClientRect();

        this.dragElement.style.position = 'absolute';
        this.dragElement.style.opacity = 0;
        this.startPositionLeft = globalPosition.left;
        this.startPositionTop = globalPosition.top;

        this.dragElement.style.left = this.startPositionLeft + 'px';
        this.dragElement.style.top = this.startPositionTop + 'px';

        this.callBackFunction = callBackFunction;
        this.dragOffset = this.getDragOffset(dragOffset);
        this.isSlide = isSlide;

        this.clearScrollInverval();
    },
    onDragMove(offsetX, offsetY, e) {
        var target = this.dragElement;

        if (target == undefined)
            return;

        target.style.opacity = 0.8;
        target.style.top = (this.startPositionTop + offsetY) + 'px';

        var newLeftPos;

        if (e)
            newLeftPos = mouseUtils.getTouchPosition(e).x - this.dragOffset.x;
        else
            newLeftPos = this.startPositionLeft + offsetX + this.gap;

        if (this.isSlide) {
            if (newLeftPos > this.getLeftLimit() && newLeftPos < this.getRightLimit())
                target.style.left = newLeftPos + 'px';
        } else
            target.style.left = newLeftPos + 'px';

        this.checkPosition(offsetX, offsetY);

        if (this.isSlide)
            this.checkScroll(offsetX, e);
    },

    moveScroll: undefined,
    positionValue: 1,
    scrollTimerVar: undefined,
    checkScroll(offsetX, e) {
        var position = mouseUtils.getTouchPosition(e);

        if (position.x > this.getLeftLimit() && position.x < this.getRightLimit()) {
            this.clearScrollInverval();
            return;
        }

        if (position.x >= this.getRightLimit()) {
            if (!this.scrollTimerVar) {
                this.positionValue = 1;
                this.scrollTimerVar = setInterval(this.moveScrollAtInterval.bind(this), 100);
                this.moveScroll();
            }

        } else if (position.x <= this.getLeftLimit()) {
            if (!this.scrollTimerVar) {
                this.positionValue = -1;
                this.scrollTimerVar = setInterval(this.moveScrollAtInterval.bind(this), 100);
                this.moveScroll(-1);
            }
        }
    },
    moveScrollAtInterval() {
        this.moveScroll(this.positionValue);
    },
    clearScrollInverval() {
        if (this.scrollTimerVar)
            clearInterval(this.scrollTimerVar);

        this.scrollTimerVar = undefined;
    },
    getLeftLimit() {
        return properties.BUTTONS_HOLDER_WIDTH;
    },
    getRightLimit() {
        const state = storeManager.getState();
        var windowWidth = state.production.windowWidth;
        var accordionWidth = state.accordion.width;

        if (!(windowWidth > 0))
            windowWidth = window.innerWidth;

        if (accordionWidth == undefined)
            accordionWidth = properties.BROWSER_WIDTH;

        return (windowWidth - accordionWidth);
    },

    onDragEnd(offsetX, offsetY) {
        if (this.dragElement == undefined)
            return;

        this.checkDropPosition(offsetX, offsetY);

        if (this.dragElement && this.dragElement.parentNode)
            document.body.removeChild(this.dragElement);

        this.startPositionLeft = 0;
        this.startPositionTop = 0;
        this.dragElement = undefined;
        this.offsetPoint = undefined;
        this.isSlide = false;
        this.gap = 0;

        this.clearScrollInverval();
    },
    checkPosition(offsetX, offsetY) {
        const scaleProperties = this.scaleProperties;
        const dragOffset = this.dragOffset;

        const clientX = this.startPositionLeft + offsetX + dragOffset.x;
        const clientY = this.startPositionTop + offsetY + dragOffset.y;
        var icon = document.getElementById('dropIcon');

        if (icon == undefined)
            return;

        if (clientX >= scaleProperties.topX && clientX <= (scaleProperties.topX + configuration.CANVAS_WIDTH * scaleProperties.scale) && clientY >= scaleProperties.topY && clientY <= (scaleProperties.topY + configuration.CANVAS_HEIGHT * scaleProperties.scale)) {
            icon.style.borderColor = 'green';
        } else {
            icon.style.borderColor = 'red';
        }
    },
    checkDropPosition(offsetX, offsetY) {
        const range = 40;

        if (Math.abs(offsetX) < range && Math.abs(offsetY) < range) { // it's a click
            if (this.callBackFunction != undefined)
                this.callBackFunction();

            return;
        }

        if (this.isSlide == true)
            return;

        const scaleProperties = this.scaleProperties;
        const dragOffset = this.dragOffset;

        const clientX = this.startPositionLeft + offsetX + dragOffset.x;
        const clientY = this.startPositionTop + offsetY + dragOffset.y;

        if (clientX >= scaleProperties.topX && clientX <= (scaleProperties.topX + configuration.CANVAS_WIDTH * scaleProperties.scale) && clientY >= scaleProperties.topY && clientY <= (scaleProperties.topY + configuration.CANVAS_HEIGHT * scaleProperties.scale)) {
            var topLeftPosition = {};
            const scale = scaleProperties.scale;
            topLeftPosition.x = (clientX - scaleProperties.topX) / scale;
            topLeftPosition.y = (clientY - scaleProperties.topY) / scale;

            if (this.callBackFunction != undefined)
                this.callBackFunction(topLeftPosition);
        }
    },
    getDropIndex(index, slides, offsetX, offsetY) {
        if (!this.dragOffset)
            return -1;

        const slideWidth = properties.SLIDE_ITEM_WIDTH + properties.SLIDE_GAP;
        const slideHeight = 9/ 16 * slideWidth;
        const currentYPosition = this.dragOffset.y + offsetY;

        if (currentYPosition < 0 || currentYPosition > slideHeight)
            return -1;

        const currentXPosition = offsetX;
        var dropOffset = Math.floor(currentXPosition / slideWidth);
        const localDif = Math.abs(offsetX) - Math.abs(dropOffset * slideWidth);

        if (localDif > slideWidth / 2) {
            dropOffset = dropOffset + 1;
        }

        if (offsetX < 0)
            dropOffset = dropOffset + 1;

        var dropIndex = index + dropOffset;

        if (dropIndex < 0)
            dropIndex = 0;

        if (offsetX < 0 && dropIndex != index)
            this.gap = properties.SLIDE_PADDING_DROP;
        else
            this.gap = 0;

        return dropIndex;
    },
    clientX: -1,
    getDropIndexNew(dragIndex, slides, offsetX, offsetY) {
        const slideHeight = 9/ 16 * slideWidth;

        if (!this.dragOffset)
            return 0;

        const currentYPosition = this.dragOffset.y + offsetY;

        if (currentYPosition < 0 || currentYPosition > slideHeight)
            return -1;

        var i;
        var slideWidth;
        var start = 0;
        var currentX = this.clientX + offsetX;
        var dropIndex;

        for (i=0; i<slides.length; i++) {
            if (!slides[i] || !slides[i].time)
                continue;

            slideWidth = audioEditorUtils.getSlideWidth(slides[i].time);

            if (currentX >= start && currentX <= (start + slideWidth)) {
                if (currentX < (start + slideWidth / 2))
                    dropIndex = i;
                else
                    dropIndex = i + 1;

                break;
            }

            start = start + slideWidth;
        }

        if (dropIndex < 0)
            dropIndex = 0;

        if (dropIndex > (slides.length - 1))
            dropIndex = slides.length - 1;

        if (!dropIndex) {
            if (offsetX > 0)
                return slides.length - 1;
            else
                return 0;
        }

        return dropIndex;
    }
};

export default dragManager;



/** WEBPACK FOOTER **
 ** ./src/components/utils/DragManager.js
 **/